import type { NuxtApp } from '#app'
import LvlIoUi from '@/ui-core'
import avatarDefaultSrc from '~/components/base/avatar/avatar.png?url'

export default defineNuxtPlugin(nuxtApp => {
  type __NuxtApp = typeof nuxtApp & Pick<NuxtApp, '$i18n' | '$normalizePath'>

  const { $i18n, $normalizePath } = nuxtApp as __NuxtApp

  nuxtApp.vueApp.use(LvlIoUi, {
    iconImportObject: import.meta.glob('/app/icons/*.svg'),
    avatarDefaultSrc,
    teleportTo: '#teleports',
    locale: $i18n.locale.value,
    normalizePath: $normalizePath
  })
})
